import styled from 'styled-components'

export const Background = styled.div`
  position: relative;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  background: ${({ theme }) => theme.colors.boxBackground};
  box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem 2rem 1rem;
`

export const GoToCheckoutButtonWrapper = styled.div`
  max-width: 30rem;
  width: 100%;
`
